import i18n from 'i18next';

export const GetDescriptionByLanguage = (descriptionFr: string, descriptionEn: string): string => {
  if (i18n.language.includes('en')) {
    return descriptionEn;
  }
  return descriptionFr;
};
